import { Action } from '@ngrx/store';
import { CommentDto, SupportedAggregateTypes } from '../../models/comment.model';
import { DsmApiResponseDataDto } from '../../models/dsm-api-call.model';

export const REHYDRATE = '[Layout] Rehydrate';

//----------------------------------------------------------------------------------------------------
// Loading comments
//----------------------------------------------------------------------------------------------------

export const LOAD_COMMENTS_PAGE = '[Common:Comment] Load comments page';
export const LOAD_COMMENTS_PAGE_SUCCESS = '[Common:Comment] Load comments page successful';
export const LOAD_COMMENTS_PAGE_FAILURE = '[Common:Comment] Load comments page failed';

export interface LoadCommentsPagePayload {
  aggregateId: string;
  aggregateType: SupportedAggregateTypes;
  limit: number;
  offset: number;
  autoLoadNextPage: boolean;
}

export interface LoadCommentsPageSuccessPayload {
  request: LoadCommentsPagePayload;
  response: DsmApiResponseDataDto;
}

export interface LoadCommentsPageErrorPayload {
  request: LoadCommentsPagePayload;
  error: any;
}

export class LoadCommentsPage implements Action {
  readonly type = LOAD_COMMENTS_PAGE;
  constructor(public payload: LoadCommentsPagePayload) {}
}

export class LoadCommentsPageSuccessful implements Action {
  readonly type = LOAD_COMMENTS_PAGE_SUCCESS;
  constructor(public payload: LoadCommentsPageSuccessPayload) {}
}

export class LoadCommentsPageFailed implements Action {
  readonly type = LOAD_COMMENTS_PAGE_FAILURE;
  constructor(public payload: LoadCommentsPageErrorPayload) {}
}

//----------------------------------------------------------------------------------------------------
// Write comments (create / update)
//----------------------------------------------------------------------------------------------------
export const WRITE_COMMENT = '[Common:Comment] Write comment';
export const WRITE_COMMENT_SUCCESS = '[Common:Comment] Write comment successful';
export const WRITE_COMMENT_FAILURE = '[Common:Comment] Write comment failed';

export interface WriteCommentRequestPayload {
  comment: CommentDto;
}

export interface WriteCommentSuccessPayload {
  request: WriteCommentRequestPayload;
  response: CommentDto;
}

export interface WriteCommentErrorPayload {
  request: WriteCommentRequestPayload;
  error: any;
}

export class WriteComment implements Action {
  readonly type = WRITE_COMMENT;
  constructor(public payload: WriteCommentRequestPayload) {}
}

export class WriteCommentSuccessful implements Action {
  readonly type = WRITE_COMMENT_SUCCESS;
  constructor(public payload: WriteCommentSuccessPayload) {}
}

export class WriteCommentFailed implements Action {
  readonly type = WRITE_COMMENT_FAILURE;
  constructor(public payload: WriteCommentErrorPayload) {}
}

//----------------------------------------------------------------------------------------------------
// Delete comments
//----------------------------------------------------------------------------------------------------
export const DELETE_COMMENT = '[Common:Comment] Delete comment';
export const DELETE_COMMENT_SUCCESS = '[Common:Comment] Delete comment successful';
export const DELETE_COMMENT_FAILURE = '[Common:Comment] Delete comment failed';

export interface DeleteCommentRequestPayload {
  referencedAggregateId: string;
  referencedAggregateType: SupportedAggregateTypes;
  aggregateId: string;
}

export interface DeleteCommentSuccessPayload {
  request: DeleteCommentRequestPayload;
  response: DsmApiResponseDataDto;
}

export interface DeleteCommentErrorPayload {
  request: DeleteCommentRequestPayload;
  error: any;
}

export class DeleteComment implements Action {
  readonly type = DELETE_COMMENT;
  constructor(public payload: DeleteCommentRequestPayload) {}
}

export class DeleteCommentSuccessful implements Action {
  readonly type = DELETE_COMMENT_SUCCESS;
  constructor(public payload: DeleteCommentSuccessPayload) {}
}

export class DeleteCommentFailed implements Action {
  readonly type = DELETE_COMMENT_FAILURE;
  constructor(public payload: DeleteCommentErrorPayload) {}
}

export type Actions =
  | LoadCommentsPage
  | LoadCommentsPageSuccessful
  | LoadCommentsPageFailed
  | WriteComment
  | WriteCommentSuccessful
  | WriteCommentFailed
  | DeleteComment
  | DeleteCommentFailed
  | DeleteCommentSuccessful;
